import { ROLES, startApp } from '@horof/shared';
import { App } from './App';
import './readings.css';

// Every role can enter readings.
startApp({ allow: ROLES, App });
